import { render, staticRenderFns } from "./PropertyRequests.vue?vue&type=template&id=783a92cf&"
import script from "./PropertyRequests.vue?vue&type=script&lang=js&"
export * from "./PropertyRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports